'use client'

import { useCart } from '@/lib/cart'

/**
 * Opens the bag drawer. Reads the live count from the cart store, which is
 * empty on the server and on the first client render (the persisted bag loads
 * after mount), so the SSR markup and hydration always agree on "Cart (0)".
 */
export default function CartTrigger({ className }: { readonly className?: string }) {
  const { count, open, setOpen } = useCart()
  return (
    <button
      type="button"
      className={className}
      onClick={() => setOpen(true)}
      aria-haspopup="dialog"
      aria-expanded={open}
      data-cart-trigger=""
      data-cart-count={count}
    >
      {`Cart (${count})`}
    </button>
  )
}
